import { DURING_STAY_SURVEY_GET_ANSWER_ERROR } from './../const';

function action() {
  return { type: DURING_STAY_SURVEY_GET_ANSWER_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/duringStaySurveyGetAnswerError.js